/**
 * Single source of truth for which paths belong to the AppShell layout route,
 * and which of those hide the fixed mobile tab bar. Shared by `App.tsx`
 * (footer bottom-padding) and `AppShell.tsx` (the tab bar itself) so the two
 * never drift apart.
 */
const SHELL_PATH_PREFIXES = ['/dashboard', '/admin', '/feed'];

/** True for any path AppShell owns (header chrome, nav, tab bar apply). */
export function isShellPath(pathname: string): boolean {
  return SHELL_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

/**
 * True where the fixed mobile tab bar (and the <main>/footer bottom padding
 * that clears it) must stay hidden — the subscription form needs that space
 * for its own sticky action bar (F15).
 */
export function isTabBarHidden(pathname: string): boolean {
  return pathname.startsWith('/dashboard/subscription');
}
